import React from 'react';
import { connect } from 'react-redux';

import * as actions from '../../actions/organization/organization';

import OrganizationComponent from '../../components/app/Organization/Organization';

const Organization = (props) => {
  return (
    <OrganizationComponent {...props} />
  );
};

export default connect(({ organization, user }) => ({ organizationMain: organization.organization, user }), actions)(Organization);

